<button
    (click)="click()"
    [class]="componentClass"
    [title]="title">
    <ng-content></ng-content>
</button>
